export default "__VITE_ASSET__BK65PbZm__"